export const GET_ORGANIZATION_IAAC = "get_organization_iaac";
export const GET_ORGANIZATION_IAAC_SUCCESSFUL = "get_organization_iaac_successful";
export const GET_ORGANIZATION_IAAC_FAILURE = "get_organization_iaac_failure";

export const GET_ORGANIZATION_IAAC_LICENSES = "get_organization_iaac_licenses";
export const GET_ORGANIZATION_IAAC_LICENSES_SUCCESSFUL = "get_organization_iaac_licenses_successful";
export const GET_ORGANIZATION_IAAC_LICENSES_FAILURE = "get_organization_iaac_licenses_failure";

export const PUT_ORGANIZATION_IAAC_SUBSCRIPTION = "put_organization_iaac_subscription";

export const POST_ORGANIZATION_IAAC = "post_organization_iaac";
export const POST_ORGANIZATION_IAAC_SUCCESSFUL = "post_organization_iaac_successful";
export const POST_ORGANIZATION_IAAC_FAILURE = "post_organization_iaac_failure";

export const PUT_ORGANIZATION_IAAC = "put_organization_iaac";
export const PUT_ORGANIZATION_IAAC_SUCCESSFUL = "put_organization_iaac_successful";
export const PUT_ORGANIZATION_IAAC_FAILURE = "put_organization_iaac_failure";

export const DELETE_ORGANIZATION_IAAC = "delete_organization_iaac";
export const DELETE_ORGANIZATION_IAAC_SUCCESSFUL = "delete_organization_iaac_successful";
export const DELETE_ORGANIZATION_IAAC_FAILURE = "delete_organization_iaac_failure";

export const CLEAR_ALL_ORGANIZATION_IAAC_MESSAGES = "clear_all_organization_iaac_messages";
export const CLEAR_ALL_ORGANIZATION_IAAC_MESSAGES_SUCCESSFUL = "clear_all_organization_iaac_messages_successful";
